/**
 * @param {object | null | undefined} inv — hirelane_candidate_interviews row
 * @returns {string}
 */
export function interviewAttendeesSummary(inv) {
  const arr = inv?.interview_attendees;
  if (Array.isArray(arr) && arr.length > 0) {
    const parts = arr.map((a) => (a?.name || a?.email || '').trim()).filter(Boolean);
    if (parts.length) return parts.join(' · ');
  }
  const legacy = (inv?.interviewer_name || '').trim();
  return legacy || '';
}
